/**
*
* SavePlanErrorDialog
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import messages from './messages';
import Description from './Description';
import { KompisPrompt } from '@inter-ikea-kompis/react-components';
import { PromptButtonTypeEnum } from '@inter-ikea-kompis/component-prompt';
import { SkapaTheme } from '@inter-ikea-kompis/themes';


function SavePlanErrorDialog({ show, onDismiss, loading, onSave, cwcalcReachedFromIpexGallery }) {
  const { formatMessage } = useIntl();

  return (
    <KompisPrompt
      heading={formatMessage({
        id: messages.vpcSaveErrorTitle.id, defaultMessage: messages.vpcSaveErrorTitle.defaultMessage
      })}
      primaryButtonLabel={formatMessage({
        id: messages.vpcSaveRetrySave.id, defaultMessage: messages.vpcSaveRetrySave.defaultMessage
      })}
      onButtonClick={event => {
        onDismiss();
        if (event.detail.type === PromptButtonTypeEnum.primaryButton) {
          // onContinueClick();
          onSave();
        } else {
          // onBackClick();
          loading();
        }
      }}
      visible={show}
      theme={SkapaTheme}
      disableIframeSticky={cwcalcReachedFromIpexGallery}
    >
      <Description text={formatMessage({id: messages.vpcSaveErrorSubtitle.id, defaultMessage: messages.vpcSaveErrorSubtitle.defaultMessage})}/>
    </KompisPrompt>)
}

SavePlanErrorDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  onDismiss: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default SavePlanErrorDialog;
